<template>
    <b-card-body>
        <b-card-title
            title-tag="h1">
            {{ newsCardTitle }}
        </b-card-title>
        <template v-if="newsItems && newsItems.length > 0">
            <b-list-group flush>
                <b-list-group-item
                    v-for="(newsItem, key, index) in newsItems"
                    :key="index"
                    :href="getLinkHref(newsItem)"
                    target="_blank"
                    class="bg-transparent"
                    @click="performClick(newsItem, $event)">
                    <div>
                        <h2 class="list-group-item-title">{{ newsItem.linkText }}</h2>
                        <span
                            class="list-group-item-detail"
                            v-html="newsItem.articleBlurb"></span>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </template>
    </b-card-body>
</template>

<script>
import LandingContentBaseComponent from './LandingContentBaseComponent.vue';

// TODO:    Make NewsContentCard and LinksContentCard just one flexible component,
//          since they're effectively doing the same thing.
export default {
    name: 'NewsContentCard',
    extends: LandingContentBaseComponent,
    props: {
        newsCardTitle: {
            type: String,
            required: true,
            default: 'Default Title'
        },
        newsCardBundle: {
            type: String,
            required: true,
            default: 'DefaultContentPath'
        }
    },

    data() {
        return {newsItems: []};
    },

    mounted() {
        // Pull in content from WCM the list of links
        this.initializeContent().then(() => {
            this.setUpLinks();
        });
    },

    methods: {
        setUpLinks: function () {
            const bundle = this.getBundle(this.newsCardBundle);
            const news = [];

            if (bundle) {
                Object.keys(bundle).forEach((key) => {
                    const newsJson = bundle[key];
                    news.push(newsJson);
                });
                // sort by order
                news.sort((a, b) => a.order - b.order);
            }
            this.newsItems = news;
        },
        isInternalLink: function (newsItem) {
            return newsItem.internal;
        },

        getLinkHref: function (newsItem) {
            let href = "#";

            if (!this.isInternalLink(newsItem)) {
                href = newsItem.url;
            }

            return href;
        },

        performClick: function (newsItem, event) {
            if (this.isInternalLink(newsItem)) {
                event.stopPropagation();
                this.routeToName('link', {
                    linkCardTitle: this.newsCardTitle,
                    linkCardBundle: this.newsCardBundle,
                    linkTitle: newsItem.linkText,
                    linkContentItem: newsItem.contentName
                });
            }
        }
    }
};
</script>